<template>
<ScreenLayout>
    <div slot="left">

    </div>

    <div class="pa-5">

        <p>
            Insight Processing is committed to providing you with the best possible customer service experience. Insight Processing is bound by the Privacy Act 1988, which sets out a number of principles concerning the privacy of individuals.
        </p>    
        <p>
            <b>Collection of your personal information</b><br/>
            There are many aspects of the site which can be viewed without providing personal information, however, for access to future Insight Processing customer support features you are required to submit personally identifiable information. This may include but not limited to a unique username and password, or provide sensitive information in the recovery of your lost password.

        </p>    
        <p>
            <b>Sharing of your personal information</b><br/>
            We may occasionally hire other companies to provide services on our behalf, including but not limited to handling customer support enquiries, processing transactions or customer freight shipping. Those companies will be permitted to obtain only the personal information they need to deliver the service. Insight Processing takes reasonable steps to ensure that these organisations are bound by confidentiality and privacy obligations in relation to the protection of your personal information.

        </p>    
        <p>
            <b>Use of your personal information</b><br/>
            For each visitor to reach the site, we expressively collect the following non-personally identifiable information, including but not limited to browser type, version and language, operating system, pages viewed while browsing the Site, page access times and referring website address. This collected information is used solely internally for the purpose of gauging visitor traffic, trends and delivering personalized content to you while you are at this Site.

        </p>    
        <p>
            From time to time, we may use customer information for new, unanticipated uses not previously disclosed in our privacy notice. If our information practices change at some time in the future we will use for these new purposes only, data collected from the time of the policy change forward will adhere to our updated practices.

        </p>    
        <p>
            <b>Changes to this Privacy Policy</b><br/>
            Insight Processing reserves the right to make amendments to this Privacy Policy at any time. If you have objections to the Privacy Policy, you should not access or use the Site.

        </p>    
        <p>
            <b>Accessing Your Personal Information</b><br/>
            You have a right to access your personal information, subject to exceptions allowed by law. If you would like to do so, please let us know. You may be required to put your request in writing for security reasons. Insight Processing reserves the right to charge a fee for searching for, and providing access to, your information on a per request basis.

        </p>    
        <p>
            <b>Contacting us</b><br/>
            Insight Processing welcomes your comments regarding this Privacy Policy. If you have any questions about this Privacy Policy and would like further information, please contact us by any of the following means during business hours Monday to Friday.
            

        </p>    

    </div>
    <div slot="right">
        
    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'

export default {
    name: 'Template',
    components: {ScreenLayout},
    data() {
        return {

        }
    },
    computed:{

    },
    methods: {

    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// PrivacyPolicy.vue?32379060